import { German } from "../_localized/de";
import { English } from "../_localized/en";
import { Spanish } from "../_localized/es";
import { French } from "../_localized/fr";
import { Norwegian } from "../_localized/no";

// Update allLocalizations when adding new localizations
export const allLocalizations: { [key: string]: any } = {
  en: English,
  de: German,
  no: Norwegian,
  es: Spanish,
  fr: French,
};

export class Localized {
  static providers: any[] = [];
  static locales: string[] = [];

  static pushLocale(locale: string, provider: any) {
    // locale = localization file name (en.ts) vs provider = language name (English)
    Localized.locales = Localized.locales.filter((item) => item !== locale);
    Localized.providers = Localized.providers.filter(
      (item) => item !== provider,
    );
    Localized.providers.unshift(provider);
    Localized.locales.unshift(locale);
  }

  static object(address: string): any {
    return Localized.get(address);
  }

  static get(address: string): any {
    for (let i = 0; i < Localized.providers.length; i++) {
      const value = resolveAddress(address, Localized.providers[i]);
      if (value !== undefined) {
        return value;
      }
    }
    return undefined;
  }

  static string(address: string, ...parameters: any): string {
    const value = Localized.get(address);
    if (value === undefined || typeof value !== "string") {
      return String(address);
    }

    // parameters substituted into string:
    //   '${0} == parameter 1', '${1} == parameter 2', etc
    if (parameters && parameters.length > 0) {
      const strings = value.split(/(\$\{\d+\})/);
      return strings
        .map((s: any) => {
          const str = s + "";
          const matches = str.match(/^\$\{(\d+)\}$/);
          if (matches) {
            const index = parseInt(matches[1]);
            return index < parameters.length ? parameters[index] : s;
          } else {
            return s;
          }
        })
        .join("");
    }

    return value;
  }

  static array<T>(address: string): Array<T> {
    const value = Localized.get(address);
    if (value === undefined || !Array.isArray(value)) {
      return [];
    }
    return value;
  }
}

function resolveAddress(address: string, obj: any): any | undefined {
  const keys = address.split(".");
  let current = obj;
  for (let i = 0; i < keys.length; i++) {
    if (current === undefined || typeof current !== "object") {
      return undefined;
    }
    current = current[keys[i]];
  }
  return current;
}
